module.exports = __webpack_public_path__ + "media/test/step_3-0ca3ee7e.png";